import React from "react";
import 'leaflet/dist/leaflet.css';
import "./ContentAddress.scss";
import FCMap from "../../FCObjets/FCMap";
import {useFetchAddressBook} from "../../../service/Business/MapService";
import FCAlertMsgErrorAPI from "../../FCObjets/FCAlertMsg/FCAlertMsgErrorAPI";


const ContentAddress: React.FunctionComponent = () => {

    const {data: addressBook, loading, error} = useFetchAddressBook();

    return (
        <div className="addressPage">
            <div className="addressMapWrapper">
                <FCMap listMarkerAddressBook={(!loading && !error) ? addressBook : []} zoomMap={10}/>
            </div>
            {error && <FCAlertMsgErrorAPI error={error}/>}
        </div>
    );
}


export default ContentAddress;